export const unsavedChangesDlgConstants = {
  CONTENT: 'You have unsaved changes in the configuration panel.\n\rIf you return to the worklist without saving your changes, all changes will be lost.',
  TITLE: "Unsaved changes",
  APPROVE_BTN: "Continue editing",
  DECLINE_BTN: "Discard changes"
}
